import {
  faArrowsFromLine,
  faArrowsToLine,
} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Trigger} from '@radix-ui/react-collapsible';
import clsx from 'clsx';

type Props = React.ComponentProps<typeof Trigger> & {
  isOpen: boolean;
};
export function CollapsibleTrigger({
  className,
  children,
  isOpen,
  ...props
}: Props): React.JSX.Element {
  const cn = clsx(className, 'relative flex items-center');

  return (
    <div className={cn}>
      {children}

      <Trigger
        {...props}
        className="absolute inset-y-0 right-0 ml-2 h-6 w-6 cursor-pointer rounded-full border-2 border-slate6 p-1 focus:border-blue7 focus:outline-hidden radix-disabled:border-slate7 radix-disabled:bg-slate3 radix-state-open:border-blue8"
      >
        <FontAwesomeIcon
          icon={isOpen ? faArrowsToLine : faArrowsFromLine}
          className="absolute inset-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2"
          aria-hidden="true"
          size="xs"
        />
      </Trigger>
    </div>
  );
}

CollapsibleTrigger.displayName = 'CollapsibleTrigger';
